export default {
      id: "icon-tiktok-usage",
      viewBox: "0 0 67 67",
      url: "../icon/" + "icons.svg#icon-tiktok-usage",
      toString: function () {
        return this.url;
      }
    }